<mat-form-field class="autocomplete-field">
  <input matInput [matAutocomplete]="autocomplete" [formControl]="control" autocomplete="off" />
  <mat-error>
    <lin-form-field-error></lin-form-field-error>
  </mat-error>
</mat-form-field>

<mat-autocomplete #autocomplete="matAutocomplete" [displayWith]="displayWith">
  @if (isAutocompleteLoading) {
  <mat-option>
    @if (control?.value?.length >= 2) {
    <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
    } @else {
    <span class="placeholder">{{ 'PLACEHOLDERS.AUTOCOMPLETE' | translate }}</span>
    }
  </mat-option>
  } @if (!isAutocompleteLoading) { @for (option of autocompleteOptions; track $index) {
  <mat-option [value]="option">
    <span>{{ displayWith(option) }}</span>
  </mat-option>
  } }
</mat-autocomplete>
